module.exports = __webpack_public_path__ + "logo_132-966a6a6a490769a3ba3286f6df2f70a6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_132.png
// module id = 1132
// module chunks = 0 1